import { httpRequest } from '../ui-utils/api'
import { backendHosts, apiUrl } from '../ui-utils/apiConfig'

const kycDetails = async () => {
    try {
        const kycData = await httpRequest({
            endPoint: `${backendHosts.ADMIN}${apiUrl.kycPending}`,
            method: "get",
            instance: "instanceTwo",
        })
        if (kycData.status === 200) {
            console.log(kycData.data, 'kyc details')
        }
        // Dev Srini 25/10/24
        else{
            console.log('Error in Kyc Pending API', kycData)
        }
    }
    catch (error) {
        console.log('Error In Kyc Pending API', error)
    }
}

export default kycDetails